import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'

const Login = () => import('@/views/Login')
const EmptyPage = () => import('@/views/EmptyPage')
const User = () => import('@/views/User')
const Offline = () => import(/* webpackPrefetch: true */ '@/views/Offline')

const Home = () => import(/* webpackPrefetch: true */ '@/views/Home')
const Label = () => import(/* webpackChunkName: "label" */ /* webpackPrefetch: true */ '@/views/Label')
const DigitalLabel = () => import(/* webpackChunkName: "label" */ /* webpackPrefetch: true */ '@/views/DigitalLabel')
const LabelResume = () => import(/* webpackChunkName: "label" */ /* webpackPrefetch: true */ '@/views/LabelResume')
const Library = () => import('@/views/Library')
const Allergens = () => import('@/views/Allergens')
const Tasks = () => import(/* webpackChunkName: "appcc" */ '@/views/Tasks')
const Register = () => import(/* webpackChunkName: "appcc" */ '@/views/Register')
const Audit = () => import(/* webpackChunkName: "appcc" */ '@/views/Audit')
const Issues = () => import(/* webpackChunkName: "appcc" */ '@/views/Issues')
const Config = () => import('@/views/Config')
const Release = () => import('@/views/Release')
const Ticket = () => import('@/views/Ticket')
const HomeWidgets = () => import('@/views/HomeWidgets')
const Sensors = () => import('@/views/Sensors')
const TimerProduct = () => import('@/views/TimerProduct')
const Production = () => import('@/views/Production')
const Pls = () => import('@/views/Pls')
const PlsStock = () => import('@/views/PlsStock')
const PhuProduction = () => import('@/views/PhuProduction')
const Chat = () => import('@/views/Chat')
const Timers = () => import('@/views/Timers')
const Landing = () => import('@/views/Landing')
const Alerts = () => import('@/views/Alerts')
const ActionPlan = () => import('@/views/ActionPlan')
const Sales = () => import('@/views/Sales')
// import Logbook from "@/views/Logbook";
const IconsGallery = () => import('@/views/IconsGallery')
const ZPLEditor = () => import('@/views/ZPLEditor')
const AndyAgents = () => import('@/views/AndyAgents')
const Radar = () => import('@/components/domain/radar/Radar.vue')

Vue.use(Router)

const KITCHEN_MODE_ALLOWED_ROUTES = ['/traceability', '/timers', '/library', '/sensor', '/homewidgets', '/guide', '/guide/advanced-settings', '/pls']

const canAccessKitchenModeRoute = (route) => store.getters.isKitchenModeActive && KITCHEN_MODE_ALLOWED_ROUTES.includes(route.path)

export default new Router({
    mode: process.env.VUE_APP_URL_TYPE == 'HASH' ? 'hash' : 'history',
    routes: [
        {
            path: '/blank',
            name: 'Blank',
            component: EmptyPage,
            beforeEnter: checkBeforeEnter
        },
        {
            // One or more segments so /reset/config/location matches (params.page may be an array)
            path: '/reset/:page+',
            name: 'Reset',
            component: EmptyPage,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/offline',
            name: 'Offline',
            component: Offline,
            meta: {
                layout: 'offline'
            }
        },
        {
            path: '/login',
            name: 'Login',
            alias: '/logout',
            component: Login,
            meta: {
                layout: 'login'
            },
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/',
            name: 'HomePage',
            redirect: () => store.getters.getHome || '/home',
            component: Home,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/home',
            name: 'Home',
            component: Home,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/homewidgets',
            name: 'HomeWidgets',
            component: HomeWidgets,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/chat',
            name: 'Chat',
            component: Chat,
            beforeEnter: checkBeforeEnter
        },
        // {
        //   path: "/logbook",
        //   name: "Logbook",
        //   component: Logbook,
        //   beforeEnter: checkBeforeEnter
        // },
        // {
        //   path: "/logbook/add/",
        //   name: "LogbookAdd",
        //   component: Logbook,
        //   beforeEnter: checkBeforeEnter
        // },
        // {
        //   path: "/logbook/:id",
        //   name: "LogbookDetail",
        //   component: Logbook,
        //   beforeEnter: checkBeforeEnter
        // },
        // {
        //   path: "/logbook/edit/:id",
        //   name: "LogbookEdit",
        //   component: Logbook,
        //   beforeEnter: checkBeforeEnter
        // },

        {
            path: '/label',
            name: 'Label',
            component: Label,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/sensor',
            name: 'Sensor',
            component: Sensors,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/sensor/:id',
            name: 'SensorDetail',
            component: Sensors,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/product',
            name: 'TimersProduct',
            component: TimerProduct,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/guide/advanced-settings',
            name: 'ForecastAdvancedSettings',
            component: Production,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/guide',
            name: 'Production',
            component: Production,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/pls',
            name: 'Pls',
            component: Pls,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/stock-pls',
            name: 'PlsStock',
            component: PlsStock,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/phu-production',
            name: 'PhuProduction',
            component: PhuProduction,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/sales',
            name: 'Sales',
            component: Sales,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/label/queue',
            name: 'LabelQueue',
            component: Label,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/traceability',
            name: 'DigitalLabel',
            component: DigitalLabel,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/label/resume',
            name: 'LabelResume',
            component: LabelResume,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/timers',
            name: 'Timers',
            component: Timers,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/allergens',
            name: 'Allergens',
            component: Allergens,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/library',
            name: 'Library',
            component: Library,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/library/:id',
            name: 'LibraryDetail',
            component: Library,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/checklist',
            name: 'Checklist',
            component: Tasks,
            props: { propDate: '' },
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/checklist/:id',
            name: 'ChecklistDetail',
            component: Tasks,
            //   props: { checkType: 1 },
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/user',
            name: 'user',
            component: User,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/register',
            name: 'Register',
            component: Register,
            props: { checkType: 3 },
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/register/:id',
            name: 'RegisterDetail',
            component: Register,
            props: { checkType: 3 },
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/register/:id/:edit',
            name: 'RegisterEdit',
            component: Register,
            props: { checkType: 3 },
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/audit',
            name: 'Audit',
            component: Audit,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/audit/:id',
            name: 'AuditDetail',
            component: Audit,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/audit/:id/:edit',
            name: 'AuditEdit',
            component: Audit,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/issues',
            name: 'Issues',
            component: Issues,
            // props: { checkType: 4 },
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/issues/:id',
            name: 'IssuesDetail',
            component: Issues,
            // props: { checkType: 4 },
            beforeEnter: checkBeforeEnter
        },

        {
            path: '/release',
            name: 'Release',
            component: Release,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/config',
            name: 'Config',
            component: Config,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/config/templates/:templateId',
            name: 'TemplateItems',
            component: Config,
            beforeEnter: checkBeforeEnter,
            props: true
        },
        {
            path: '/config/:page',
            name: 'ConfigPage',
            component: Config,
            beforeEnter: checkBeforeEnter,
            props: true
        },
        {
            path: '/tickets',
            name: 'Tickets',
            component: Ticket,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/dbpreview/:expiration/:location/:id/:isrbe',
            name: 'DashboardPreview',
            beforeEnter: dashboardAccess,
            meta: {
                layout: 'login'
            }
        },
        {
            path: '/inituserlogin/:id',
            name: 'LoginUserCallback',
            beforeEnter: loginUserCallbackAccess,
            meta: {
                layout: 'login'
            }
        },
        {
            path: '/logoutexternal',
            name: 'LoginUserCallback',
            beforeEnter: logoutUserCallbackAccess,
            meta: {
                layout: 'login'
            }
        },
        {
            path: '/download',
            name: 'LandingBase',
            component: Landing,
            meta: {
                layout: 'landing'
            }
        },
        {
            path: '/download/:identifier',
            name: 'LandingWithIdentifier',
            component: Landing,
            meta: {
                layout: 'landing'
            },
            props: true
        },
        {
            path: '/alerts',
            name: 'Alerts',
            component: Alerts,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/action_plan/:id',
            name: 'ActionPlan',
            component: ActionPlan,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/andy-agents',
            name: 'AndyAgents',
            component: AndyAgents,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '*',
            name: 'not_found',
            redirect: '/',
            component: Home,
            beforeEnter: checkBeforeEnter
        },
        {
            path: '/icons',
            name: 'IconsGallery',
            component: IconsGallery,
            meta: {
                layout: 'login'
            }
        },
        {
            path: '/zpl-editor',
            name: 'ZPLEditor',
            component: ZPLEditor
        },
        {
            path: '/radar',
            name: 'Radar',
            component: Radar,
            beforeEnter: checkBeforeEnter
        }
    ]
})

function checkBeforeEnter(to, from, next) {
    // if (!fnCheckConnection() && from.name == null && process.env.VUE_APP_IS_APP !== 'TRUE') {
    //     next('/offline')
    // }
    Vue.prototype.$bar.reset()
    // if (!to.query || typeof to.query.closePopup === 'undefined' || to.query.closePopup) {
    //     Vue.prototype.$popup.close()
    // }

    // if( to.name == 'Home' ){
    //   Vue.prototype.$bar.hide();
    //   store.commit('setAlexVisible', false);
    //   store.commit('setMenuToolsExpanded', true);
    // } else {
    //   Vue.prototype.$bar.show();
    //   store.commit('setAlexVisible', true);
    //   store.commit('setMenuToolsExpanded', false);
    // }

    if (store.getters.getIsAndroid && FirebasePlugin) {
        FirebasePlugin.logEvent('page_view', { content_type: 'page_view', item_id: to.name, item_name: to.path })
        FirebasePlugin.setScreenName(to.name)
    }

    if (to.name != 'Login') {
        Vue.prototype.$bar.show()
        store.commit('setAlexVisible', true)
        store.commit('setMenuToolsExpanded', false)
        store.commit('setOverlayVisible', false)
        store.commit('setMenuUserVisible', false)
        Vue.prototype.$overlay.hide()

        requireAuth(to, from, next)
    } else {
        next()
    }
}

function redirectAndyAgentsWithoutEmployee(to, next) {
    if (to.name !== 'AndyAgents' || store.getters['loginUser/getHasLoginUser']) {
        return false
    }

    next(store.getters.getRouteAfterEmployeeLogout || '/home')
    return true
}

/*
    This will cehck to see if the user is authenticated or not.
*/
function requireAuth(to, from, next) {
    /*
        Determines where we should send the user.
      */

    function proceed() {
        /*
              If the user has been loaded determine where we should
              send the user.
            */

        if (redirectAndyAgentsWithoutEmployee(to, next)) {
            return
        }

        if (store.getters['login/getHasLogin']) {
            /*
                  If the user is not empty, that means there's a user
                  authenticated we allow them to continue. Otherwise, we
                  send the user back to the home page.
                */
            next()
        } else if (!fnCheckConnection()) {
            next()
        } else {
            next('Login')
        }
    }

    log('1234', store.getters['login/isLoad'])
    if (store.getters['login/isLoad']) {
        /*
        Confirms the user has been loaded
        */
        log('1', store.getters['login/getHasLogin'])
        if (!store.getters['login/getHasLogin']) {
            /*
                If not, load the user
              */
            log('STEP 2')
            const isAuditorLogin = store.getters['isAuditorLogin']
            const isAuditorLogged = store.getters['loginUser/getAuditor']
            const isLoadedLocation = store.getters['login/getIsLoadedLocation']

            if ((!isAuditorLogin || !isAuditorLogged) && isLoadedLocation) {
                log('STEP 3.1')
                // Si no es auditor o no esta logeado como auditor y si tiene el local cargado
                store.dispatch('login/initLocation').then(function () {
                    log('THEN')
                    if (!store.getters['login/getHasLogin']) {
                        log('!getHasLogin - Go LOGIN')
                        next('Login')
                    } else {
                        // CHECK IF HAS OR NOT ROLE LEVEL TO ACCESS
                        if (!store.getters['hasAccessByRole'](to) && to.name != 'Alerts') {
                            log('ROLE ACCESS LEVEL DENIED')
                            if (redirectAndyAgentsWithoutEmployee(to, next)) {
                                return
                            }
                            if (canAccessKitchenModeRoute(to)) next()
                            else next('home')
                        } else {
                            store.dispatch('checkAppVersions').then(function () {
                                proceed()
                                // store.dispatch( 'loadPrinterInfo' ).then( function(){
                                //   proceed();
                                // });
                            })
                        }
                    }
                })
            } else if (!isAuditorLogin && !isAuditorLogged) {
                log('STEP 3.2')
                proceed()
            } else {
                log('STEP 3.3')
                store.dispatch('login/initAuditor').then(() => {
                    if (redirectAndyAgentsWithoutEmployee(to, next)) {
                        return
                    }
                    next()
                })
            }
        } else {
            /*
            User call completed, so we proceed
            */
            // store.dispatch('checkAppVersions').then(function() {
            //     proceed()
            //     // store.dispatch( 'loadPrinterInfo' ).then( function(){
            //     //   proceed();
            //     // });
            // })
            // CHECK IF HAS OR NOT ROLE LEVEL / TOOL ACCESS
            if (!store.getters['hasAccessByRole'](to) && to.name != 'Alerts') {
                log('ROLE/TOOL ACCESS DENIED')
                if (redirectAndyAgentsWithoutEmployee(to, next)) {
                    return
                }
                if (canAccessKitchenModeRoute(to)) next()
                else next('home')
            } else {
                store.dispatch('checkAppVersions').then(function () {
                    proceed()
                    // store.dispatch( 'loadPrinterInfo' ).then( function(){
                    //   proceed();
                    // });
                })
            }
        }
    } else {
        store.dispatch('login/doLoadLocalForage').then(function () {
            requireAuth(to, from, next)
        })
    }
}

function dashboardAccess(to, from, next) {
    log('dashboard access ...')
    store
        .dispatch('login/loadDashboardAccess', to.params)
        .then(function () {
            log('finish load dashboard information')
            next('/')
        })
        .catch((error) => {
            logError(error)
        })
}

function loginUserCallbackAccess(to, from, next) {
    if (store.getters['login/isLoad']) {
        if (!['error'].includes(to.params.id)) {
            const employees = store.getters['employee/getAllEmployees']
            if (Object.keys(employees).length > 0) {
                store
                    .dispatch('employee/validateExternalAccess', to.params)
                    .then(function () {
                        log('finish load loginUserCallback access')

                        next({
                            name: 'HomePage',
                            query: {
                                closePopup: false,
                                it: 1
                            }
                        })
                    })
                    .catch((error) => {
                        logError(error)
                        next({
                            name: 'HomePage',
                            query: {
                                closePopup: false,
                                it: 1
                            }
                        })
                    })
            } else {
                log('Waiting all params loaded 2...')
                setTimeout(() => {
                    loginUserCallbackAccess(to, from, next)
                }, 500)
            }
        } else {
            store.commit('employee/setErrorValidatingExternalLogin', true)
            store.commit('employee/setErrorTypeOfValidatingExternalLogin', to.query.type || false)
            next({
                name: 'HomePage',
                query: {
                    closePopup: false,
                    it: 1
                }
            })
        }
    } else {
        log('Waiting all params loaded...')
        store.commit('employee/setErrorTypeOfValidatingExternalLogin', to.query.type || false)
        store.dispatch('login/doLoadLocalForage').then(function () {
            loginUserCallbackAccess(to, from, next)
        })
    }
}

function logoutUserCallbackAccess(to, from, next) {
    if (store.getters['login/isLoad']) {
        const employees = store.getters['employee/getAllEmployees']
        if (Object.keys(employees).length > 0) {
            const id = store.getters['loginUser/getLocalEmployee']
            store
                .dispatch('loginUser/doLogout', { employee: id, external_login_complete: true })
                .then(function () {
                    log('finish load logoutUserCallbackAccess access')

                    next({
                        name: 'HomePage',
                        query: {
                            closePopup: false,
                            it: 1
                        }
                    })
                })
                .catch((error) => {
                    logError(error)
                    next({
                        name: 'HomePage',
                        query: {
                            closePopup: false,
                            it: 1
                        }
                    })
                })
        } else {
            log('Waiting all params loaded 2...')
            setTimeout(() => {
                logoutUserCallbackAccess(to, from, next)
            }, 500)
        }
    } else {
        log('Waiting all params loaded...')
        store.dispatch('login/doLoadLocalForage').then(function () {
            logoutUserCallbackAccess(to, from, next)
        })
    }
}
